import React, { Component, PropTypes } from 'react'
import moment from 'moment-timezone'

import './RecurrenceDetails.scss'
import { formatDate, pluralizedWeekday } from 'utils/dates'
import { TIMEZONE } from '@src/globals'
import { aliadas } from '@src/services/api'

class RecurrenceDetails extends Component {
  constructor (props) {
    super(props)

    this.state = {
      cost: undefined
    }
  }

  componentDidMount () {
    this.getServiceCost()
  }

  getServiceCost () {
    const { aliada, estimatedHours } = this.props.details

    return aliadas.getServiceCost(aliada.id, { estimatedHours })
      .then(cost => this.setState({ cost }))
  }

  humanizeRecurrencePeriodicity (momentDate, periodicity) {
    const recurrenceDayOfWeek = pluralizedWeekday(momentDate)

    switch (periodicity) {
      default:
      case 7:
        return `Todos los ${recurrenceDayOfWeek}`

      case 14:
        return `Los ${recurrenceDayOfWeek} cada dos semanas`
    }
  }

  isLoading () {
    return !this.state.cost
  }

  render () {
    if (this.isLoading()) {
      const Loader = () => <div />
      return <Loader />
    }

    const {
      aliada,
      weekday,
      hour,
      periodicity,
      estimatedHours
    } = this.props.details

    const { cost } = this.state

    const recurrenceMoment = moment.tz(Date.now(), TIMEZONE).day(weekday).hour(hour).minute(0)
    const recurrenceTime = formatDate('h:mm A', recurrenceMoment)

    return (
      <div>
        <div className='RecurrenceDetails-row'>
          <div>
            <p className='RecurrenceDetails-label'>
              Aliada
              <span>{aliada.firstName}</span>
            </p>
          </div>
        </div>

        <div className='RecurrenceDetails-row'>
          <div>
            <p className='RecurrenceDetails-label'>
              Dia de los servicios
              <span>{this.humanizeRecurrencePeriodicity(recurrenceMoment, periodicity)}</span>
            </p>
          </div>
        </div>

        <div className='RecurrenceDetails-row'>
          <div>
            <p className='RecurrenceDetails-label'>
              Hora del servicio
              <span>{recurrenceTime}</span>
            </p>
          </div>

          <div>
            <p className='RecurrenceDetails-label'>
              Duración del servicio
              <span>{Number.parseInt(estimatedHours)} horas</span>
            </p>
          </div>
        </div>

        <div className='RecurrenceDetails-row'>
          <div>
            <p className='RecurrenceDetails-label'>
              Costo
              <span>${cost}</span>
            </p>
          </div>
        </div>
      </div>
    )
  }
}

RecurrenceDetails.displayName = 'RecurrenceDetails'
RecurrenceDetails.propTypes = {
  details: PropTypes.shape({
    aliada: PropTypes.shape({
      firstName: PropTypes.string.isRequired
    }),
    weekday: PropTypes.string.isRequired,
    hour: PropTypes.number.isRequired,
    periodicity: PropTypes.number.isRequired,
    estimatedHours: PropTypes.string.isRequired
  }).isRequired
}
RecurrenceDetails.defaultProps = {}

export default RecurrenceDetails



// WEBPACK FOOTER //
// ./src/screens/App/screens/Recurrences/screens/RescheduleRecurrenceConfirm/components/RecurrenceDetails/RecurrenceDetails.js